'use strict';

var Debugging$PvpcontrollerWeb = require("../Debugging.js");

var pvpcapi = "https://pvpcapi.dark-gaming.com";

exports.pvpcapi = pvpcapi;
/* Debugging-PvpcontrollerWeb Not a pure module */
